import { Minus, TrendingDown, TrendingUp } from "lucide-react";

interface ValuationDeltaIconProps {
  generated?: number | null;
  confirmed?: number | null;
  className?: string;
}

export function ValuationDeltaIcon({
  generated,
  confirmed,
  className = "h-3.5 w-3.5 shrink-0",
}: ValuationDeltaIconProps) {
  if (generated == null || confirmed == null) return null;
  if (confirmed > generated) return <TrendingUp className={`text-success ${className}`} />;
  if (confirmed < generated) return <TrendingDown className={`text-error ${className}`} />;
  return <Minus className={`text-muted-foreground ${className}`} />;
}
